import {
  DataTableSlide,
  DataTableSlideProps,
} from '@/modules/presentation/components/DataTableSlide';

import { ClientPresentationSlide } from './ClientPresentationSlide';

export type PresentationDataTableSlideProps = Omit<
  DataTableSlideProps,
  'Slide' | 'rightHeaderContent'
>;

export function PresentationDataTableSlide(
  props: PresentationDataTableSlideProps
) {
  return <DataTableSlide {...props} Slide={ClientPresentationSlide} />;
}
